import ProducerService from '@/services/ProducerService'
import { DataTableFilter } from '@/types/DataTable'
import Producer from '@/types/Producer'
import { DateTime } from 'luxon'
import { computed, Ref, ref } from 'vue'

interface ProducerFilterPayload {
  label: string
  field: string
  icon: string
  initial?: string | null
}

export function useProducerFilter({
  label,
  field,
  icon,
  initial = null,
}: ProducerFilterPayload): DataTableFilter<string> {
  const loading = ref(false)

  const expires = ref<DateTime>()

  const model: Ref<string | null> = ref(initial)

  const items: Ref<Producer[]> = ref([])

  const ready = Promise.withResolvers<boolean>()

  const load = async () => {
    loading.value = true

    const service = new ProducerService()

    const response = await service.index(1, 'active=true', 100)

    items.value = response.data.data

    model.value ??= ''

    expires.value = DateTime.now().plus({ minutes: 5 })

    ready.resolve(true)

    loading.value = false
  }

  load()

  return {
    model,
    value: computed(() => model.value),
    items: computed(
      () => {
        if (expires.value !== undefined && DateTime.now() > expires.value) {
          load()
        }

        return [
          { title: 'Todos', value: '' },
          ...items.value.map(
            i => ({
              title: `${i.data.display_name}`,
              value: i.id,
            }),
          ),
        ]
      },
    ),
    label,
    field,
    icon,
    type: 'select',
    loading,
    ready: ready.promise,
    required: true,
  }
}
